import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
function AddAgency() {
  const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/Agencies")}
              />{" "}
              Add Agency
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Agency Details</div>
            <div className="addAgencyMain">
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <div className="tabLeftDiv">
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Company Name</label>
                        <input className="inputSt" placeholder="Company Name" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Website</label>
                        <input className="inputSt" placeholder="Website" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Owner Name</label>
                        <input className="inputSt" placeholder="Owner Name" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Licence Number</label>
                        <input
                          className="inputSt"
                          placeholder="Licence Number"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Registration Number</label>
                        <input
                          className="inputSt"
                          placeholder="Registration Number"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Company Adhaar</label>
                        <input
                          className="inputSt"
                          placeholder="Company Adhaar"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Company PAN</label>
                        <input className="inputSt" placeholder="Company PAN" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Contact Number</label>
                        <input
                          className="inputSt"
                          placeholder="Contact Number"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Email Id</label>
                        <input className="inputSt" placeholder="Email Id" />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <label className="tabsLabel">Address</label>
                        <textarea
                          className="textAriaSt"
                          placeholder="Address"
                        ></textarea>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="tabRightDiv">
                    <h4 className="documeUpload documeUploadIcon">Documents Upload
                    <FileUploadIcon />
                      <input 
                      type="file"
                      style={{
                        opacity: 0,
                        position: "absolute",
                        left: 0,
                      }} />
                    </h4>
                    <div id="documentDiv" className="doqumentDiv1">
                      <span>
                        samppledocumentname%here.jpg
                        <DoneIcon className="doneIcon" /> 
                      </span>

                      <Button className="documRemove"  >
                        <DeleteForeverIcon className="deleIco" />
                      </Button>
                    </div>
 
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Button className="addBt">Add</Button>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default AddAgency;
